module.exports = __webpack_public_path__ + "static/icon-self-heal-42fb13cbff30d71f66a5a5e5a94ece8a.png";